<div class="container">

  <app-header-dialog [iconName]="'noise_control_off'">
    Congresso Anterior - PDF
  </app-header-dialog>

  <div *ngIf="entityForm">

    <div class="content">

      <div style="height:150px;">

        <div style="margin-left: 20px;">
          <input type="file" #fileImage (change)="onFileSelected($event)" accept="application/pdf"
            style="display:none;">
          <a mat-raised-button (click)='fileImage.click()' matTooltip='Selecionar arquivo'
            style='background-color: whitesmoke;'>
            <mat-icon class='icon-add'>image_search</mat-icon>
            Selecionar arquivo
          </a>
          <a mat-button target="_blank" [href]="storedPDF" style="margin: 20px;">
            {{selectedFileName}}
          </a>
        </div>
        <!--
        <div style="display: flex; justify-content: center; width: 100%; margin: 20px; padding: 10px;">
          <img [src]="storedImage" style="width: 280px; height: 280px;" *ngIf="storedImage">
        </div>
       -->
      </div>

      <mat-form-field style='width: 100%;' appearance="outline">
        <mat-label>Nome</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.name"
          autocomplete="off">
      </mat-form-field>

    </div>

    <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>

      <button *ngIf="!isEdit" matTooltip='Inserir' mat-raised-button
        (click)="matDialogRef.close(['insert', entityForm, selectedFile])" [disabled]="entityForm.invalid">
        <mat-icon class='icon-done'>check_circle_outline</mat-icon>
      </button>
      <button *ngIf="isEdit" matTooltip='Alterar' mat-raised-button
        (click)="matDialogRef.close(['update', entityForm, selectedFile])" [disabled]="entityForm.invalid">
        <mat-icon class='icon-done'>check_circle_outline</mat-icon>
      </button>

    </div>

  </div>

</div>